import { SideMenu } from '@tap/mui-ui';
import { RoutesData } from '../../routes/routes';
import { ISideMenuData } from '@tap/mui-ui';
//import BidControlIcon from '../icons/action-card/services-menu/BidControlIcon';
//import BidServiceStationIcon from '../icons/action-card/services-menu/BidServiceStationIcon';
import RecommendOutlined from '@mui/icons-material/RecommendOutlined';
import BuildOutlined from '@mui/icons-material/BuildOutlined';
import ConstructionOutlined from '@mui/icons-material/ConstructionOutlined';
import SearchIcon from '@mui/icons-material/Search';
import SsidChartOutlinedIcon from '@mui/icons-material/SsidChartOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ArchiveOutlined from '@mui/icons-material/ArchiveOutlined';



/*
*   Элементы бокового меню (правое меню) на главной странице
*/

export const SideMenuHomeTopData: ISideMenuData[] = [
    {
        label: 'Главная',
        icon: <HomeOutlinedIcon />,
        link: RoutesData.home.path,
    },
    {
        label: 'Контроль качества',
        icon: <RecommendOutlined />,
        link: RoutesData.qcTaskList.path,
    },
    {
        label: 'Управление оборудованием',
        icon: <BuildOutlined />,
        link: RoutesData.ugmTaskList.path,
    },
    {
        label: 'Инструменты и СТО',
        icon: <ConstructionOutlined />,
        link: RoutesData.toolTaskList.path,
    },
    {
        label: 'НЗП и готовые материалы',
        icon: <Inventory2OutlinedIcon />,
        link: RoutesData.wipTaskList.path,
    },
    {
        label: 'Технология',
        icon: <AccountTreeOutlinedIcon />,
        link: RoutesData.techTaskList.path,
    },
];

export const SideMenuHomeMiddleData: ISideMenuData[] = [

];


export const SideMenuHomeBottomData: ISideMenuData[] = [
    {
        label: 'Входные данные',
        icon: <ArchiveOutlined />,
        link: RoutesData.inputDataPage.path,
    },
    {
        label: 'Аналитика и отчёты',
        icon: <SsidChartOutlinedIcon />,
        link: RoutesData.analytics.path,
    },
    {
        label: 'Все заявки',
        icon: <SearchIcon />,
        link: RoutesData.allTask.path,
    },
];

export function AppSideMenu() {

    return (
        <SideMenu
            topData={SideMenuHomeTopData}
            middleData={SideMenuHomeMiddleData}
            bottomData={SideMenuHomeBottomData}
        />
    );
}
